import {ClientReportListAction} from "./clientReportReducer";
import 'filepond/dist/filepond.min.css';

import React from "react";
import {ClientReportModal} from "./ClientReportModal";
import {AuthorizationInfo} from "./domain";

type ClientReportNewModalProps = {
    showModal: boolean;
    clientGuid: string;
    authorizationList: AuthorizationInfo[];
    refetch: () => void;
    dispatch: React.Dispatch<ClientReportListAction>;
}


export function ClientReportNewModal({showModal, clientGuid, dispatch, refetch, authorizationList}: ClientReportNewModalProps) {
    return <ClientReportModal showModal={showModal}
                              clientGuid={clientGuid}
                              refetch={refetch}
                              authorizationList={authorizationList}
                              hideModalFunc={() => dispatch({type: 'HIDE_NEW_MODAL'})}/>
}